export default __webpack_public_path__ + "static/googleLogo-92527d797e1ecf1f493460b1f28cd972.png";